import { useState, useRef, useEffect } from "react";
import { categories } from "@/mocks/categories";
import { Link } from "react-router-dom";

export default function HeroSection() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Elegant%20fashion%20product%20flat%20lay%20arrangement%20on%20warm%20sand%20colored%20textured%20surface%20assorted%20premium%20sneakers%20hoodies%20t-shirts%20bags%20and%20accessories%20beautifully%20styled%20with%20soft%20natural%20window%20light%20casting%20gentle%20shadows%20minimalist%20editorial%20composition%20modern%20lifestyle%20aesthetic%20cream%20and%20beige%20neutral%20color%20palette%20professional%20e-commerce%20photography%20harmonious%20organic%20layout%20with%20breathing%20space%20between%20items&width=1600&height=900&seq=hero-bg-superbuy-v4&orientation=landscape)`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45" />

      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 md:px-10 py-20 text-center">
        <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm text-white/90 text-xs md:text-sm font-medium tracking-wider uppercase mb-6">
          Curated Product Database
        </span>

        <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-white leading-tight mb-4">
          Best Superbuy Spreadsheet
          <br />
          <span className="text-white/80 font-light">for 2026</span>
        </h2>

        <p className="text-white/70 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
          Discover thousands of verified products across 14 categories. Your all-in-one gateway to smarter,
          faster, and safer Superbuy shopping with curated spreadsheets updated weekly.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 rounded-full bg-white text-foreground-900 font-semibold text-sm md:text-base hover:bg-white/90 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-shopping-cart-2-line text-lg"></i>
            Superbuy Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-flashlight-line text-lg"></i>
            Buy It Now
          </a>
        </div>

        <div className="relative inline-block" ref={dropdownRef}>
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/10 backdrop-blur-sm border border-white/25 text-white text-sm font-medium hover:bg-white/20 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-grid-line"></i>
            Browse by Category
            <i className={`ri-arrow-down-s-line transition-transform duration-200 ${dropdownOpen ? "rotate-180" : ""}`}></i>
          </button>

          {dropdownOpen && (
            <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2 w-72 max-h-72 overflow-y-auto bg-white rounded-xl shadow-lg border border-background-200 py-2 z-50">
              {categories.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
                >
                  <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-100 text-primary-500">
                    <i className={cat.icon}></i>
                  </span>
                  {cat.name}
                </a>
              ))}
            </div>
          )}
        </div>

        <div className="mt-16">
          <p className="text-white/40 text-xs tracking-widest uppercase">Trusted by International Buyers Worldwide</p>
        </div>
      </div>
    </section>
  );
}